import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const apiUrl = "https://elcobradorleague.com/api";

// Fetch con token
const fetchMatchesByLeague = async (leagueId) => {
  const { data } = await axios.get(
    `${apiUrl}/api.php?endpoint=matches&idleague=${leagueId}`,
    {      
      headers: {
          'X-API-TOKEN': process.env.REACT_APP_API_TOKEN
        },
    }
  );

  return data;
};

export const useMatches = (leagueId) => {
  return useQuery({
    queryKey: ["matches", leagueId],
    queryFn: () => fetchMatchesByLeague(leagueId),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: Number.isInteger(leagueId) && leagueId > 0,
  });
};


